import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError, AxiosResponse } from "axios";

import { useLanguageContext } from "../context/languageContext";
import { Form } from "../types/context";
import { buildFormData } from "../utils/api";
export type MainMutation = ReturnType<typeof useMainMutation>["mutate"];

   
export const useMainMutation = () =>{
  const { language } = useLanguageContext();
  return useMutation<AxiosResponse, AxiosError, Form>((data) =>
    axios.post(language==="PL"?process.env.REACT_APP_API_MUTATIONURL!:process.env.REACT_APP_API_MUTATIONURL_EN!, buildFormData(data), {
      headers: { "Content-Type": "multipart/form-data" },
    })
  );
}
 

 
